import { render, staticRenderFns } from "./TransformaTags.vue?vue&type=template&id=278f9840&scoped=true&"
import script from "./TransformaTags.vue?vue&type=script&lang=js&"
export * from "./TransformaTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278f9840",
  null
  
)

export default component.exports